"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withHtmlDeserializer = exports.withHoverButton = exports.withGlobalButton = exports.withButton = exports.withId = exports.withKey = exports.asAtomicBlock = exports.asVoid = exports.asMark = exports.asInline = exports.asBlock = exports.withComponent = void 0;

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var Type_1 = require("./Type");

function customizer(objValue, srcValue) {
  if (lodash_1.isArray(objValue)) {
    return objValue.concat(srcValue);
  }

  return undefined;
}

var withOutMeta = function withOutMeta(Component) {
  return function (props) {
    return react_1.default.createElement(Component, __assign({}, props));
  };
};
/**
 * withMeta creates an HOC that will add meta data to a React Component
 * @param meta the data to be side loaded in to the component
 */


var withMeta = function withMeta(meta) {
  return function (Component) {
    var newMeta = lodash_1.mergeWith({}, Component, meta, customizer);
    return Object.assign(withOutMeta(Component), newMeta);
  };
};
/**
 * With Component returns a function that will add the provided Componet to a RichTextItem.
 */


var withComponent = function withComponent(Component) {
  return function (CurrentComponent) {
    return Object.assign(Component, lodash_1.mergeWith({}, CurrentComponent, customizer));
  };
};

exports.withComponent = withComponent;
/**
 * asBlock returns a function that will add the fact that an item is a block to a RichTextItem.

 */

var asBlock = withMeta({
  type: Type_1.RichTextItemType.block
});
exports.asBlock = asBlock;
/**
 * asInline returns a function that will add the fact that
 * an item is an inline to a RichTextItem.
 */

var asInline = withMeta({
  type: Type_1.RichTextItemType.inline
});
exports.asInline = asInline;
/**
 * asMark returns a function that will add the fact that an item is a mark to a RichTextItem.
*/

var asMark = withMeta({
  type: Type_1.RichTextItemType.mark
});
exports.asMark = asMark;
/**
 * asVoid marks the item to be inserted as a void item
*/

var asVoid = withMeta({
  isVoid: true
});
exports.asVoid = asVoid;
/**
 * asAtomicBlock marks the item to be inserted as block
 */

var asAtomicBlock = withMeta({
  isAtomicBlock: true
});
exports.asAtomicBlock = asAtomicBlock;
/**
 * withKey will return a function that will add a keyboardKey to a RichTextItem.
*/

var withKey = function withKey(key) {
  return withMeta({
    keyboardKey: key
  });
};

exports.withKey = withKey;
/**
 * withId will return a function that will add a Id to a RichTextItem.
*/

var withId = function withId(id) {
  return withMeta({
    id: id
  });
};

exports.withId = withId;
/**
 * withGlobalButton will return a function that will add a GlobalButton to a RichTextItem.
*/

var withGlobalButton = function withGlobalButton(icon) {
  return withMeta({
    globalButton: {
      icon: icon
    }
  });
};

exports.withGlobalButton = withGlobalButton;
/**
 * withHoverButton will return a function that will add a HoverButton to a RichTextItem.
*/

var withHoverButton = function withHoverButton(icon) {
  return withMeta({
    hoverButton: {
      icon: icon
    }
  });
};

exports.withHoverButton = withHoverButton;
/**
 * withButton will return a function that will add a hover or global button depending on the type.
*/

var withButton = function withButton(icon) {
  return withHoverButton(icon);
};

exports.withButton = withButton;
/**
 * adds html deserializer to a given RichTextItem based component
 */

var withHtmlDeserializer = function withHtmlDeserializer(deserializer) {
  return withMeta({
    htmlDeserializer: deserializer
  });
};

exports.withHtmlDeserializer = withHtmlDeserializer;